import { memo, useCallback, useEffect } from 'react';
import { View, Image, Pressable, StyleSheet, Text } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__, __ANDROID__ } from '../../../constants/styles';

import FieldLabel from './field_label';
import FieldTipText from './field_tip_text';

export default memo(function (props) {
  function handlePress() {
    props.onCheck && props.onCheck(!props.checked);
  }

  if (props.label || props.labelComp) {
    return (
      <View>
        <Pressable style={[styles.btnWithLabel, props.buttonStyle]} onPress={handlePress}>
          <View
            style={[
              styles.box,
              props.style,
              props.checked ? styles.checked : null,
              props.checked ? props.checkedStyle : null,
            ]}
            onPress={handlePress}
          >
            {!!props.checked && (
              <Image
                style={[styles.icon, props.iconStyle]}
                source={require('../../../../resources/check.png')}
                resizeMode="contain"
              />
            )}
          </View>
          <FieldLabel
            disabled={false}
            noCaps={true}
            noAsteriskSpace={true}
            required={props.required}
            label={props.label}
            labelComp={props.labelComp}
            style={{ marginLeft: 10, fontSize: 16, ...FONT.medium, ...props.labelStyle }}
          />
        </Pressable>
        {!!props.required && (
          <FieldTipText
            tipText={props.tipText}
            requiredErrorText={props.requiredErrorText}
            invalidText={props.invalidText}
            label={''}
            requiredError={props.required && !props.checked}
            containerStyle={{ marginLeft: 25 }}
          />
        )}
      </View>
    );
  }

  return (
    <Pressable style={[styles.box, props.checked ? styles.checked : null]} onPress={handlePress}>
      {!!props.checked && (
        <Image
          style={[styles.icon, props.iconStyle]}
          source={require('../../../../resources/check.png')}
          resizeMode="contain"
        />
      )}
    </Pressable>
  );
});

const styles = StyleSheet.create({
  btnWithLabel: {
    flexDirection: 'row',
    marginBottom: 10,
  },
  box: {
    width: 20,
    height: 20,
    borderColor: '#777777',
    borderWidth: 1.5,
    borderRadius: 3,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
  },
  checked: {
    borderColor: '#0099cc',
    backgroundColor: '#0099cc',
  },
  icon: {
    tintColor: 'white',
    width: 10,
    height: 10,
  },
});
